export default "__VITE_ASSET__DIrQQ41F__"